import React from 'react';
import './sleep.css';

const BetterSleep = () => {
  return (
        <div className='bettersleep'>
            <h1>Tips for Better Sleep</h1>
            <p>
                Establishing healthy sleep habits and practicing good sleep hygiene can greatly improve your sleep quality and overall well-being. 
                Here are some tips to help you get better sleep:
            </p>

            <ul>
                <li>
                    <h3>Maintain a Consistent Sleep Schedule</h3>
                </li>
            </ul>
            <p style={{paddingLeft: '1rem'}}>
                Try to go to bed and wake up at the same time every day, including weekends. This helps regulate your body's internal clock and 
                promotes better sleep.
            </p>

            <ul>
                <li>
                <h3>Create a Relaxing Bedtime Routine</h3>
                </li>
            </ul>
            <p style={{paddingLeft: '1rem'}}>
                Develop a routine that helps you wind down before bed. This can include activities like reading a book, taking a warm bath, 
                practicing relaxation exercises, or listening to calming music.
            </p>

            <ul>
                <li>
                    <h3>Create a Sleep-Friendly Environment</h3>
                </li>
            </ul>
            <p style={{paddingLeft: '1rem'}}>
                Make sure your sleep environment is conducive to sleep. Keep your bedroom cool, dark, and quiet. Consider using earplugs, an eye 
                mask, or white noise machines to block out disruptive sounds.
            </p>

            <ul>
                <li>
                    <h3>Avoid Stimulants and Electronic Devices Before Bed</h3>
                </li>
            </ul>
            <p style={{paddingLeft: '1rem'}}>
                Avoid consuming caffeine or nicotine in the evening as they can interfere with sleep. Additionally, limit your exposure to electronic 
                devices, such as smartphones and laptops, before bed as the blue light emitted by these devices can disrupt your sleep-wake cycle.
            </p>

            <ul>
                <li>
                    <h3>Manage Stress and Anxiety</h3>
                </li>
            </ul>
            <p style={{paddingLeft: '1rem'}}>
                Practice stress-reduction techniques such as meditation, deep breathing exercises, or journaling to help relax your mind before 
                sleep. If anxiety or racing thoughts keep you awake, consider talking to a therapist or counselor for additional support.
            </p>

            <ul>
                <li>
                    <h3>Create a Comfortable Sleep Environment</h3>
                </li>
            </ul>
            <p style={{paddingLeft: '1rem'}}>
                Invest in a comfortable mattress, pillows, and bedding that suit your preferences. It's important to create a sleep environment 
                that promotes relaxation and physical comfort.
            </p>

            <ul>
                <li>
                    <h3>Avoid Heavy Meals and Exercise Before Bed</h3>
                </li>
            </ul>
            <p style={{paddingLeft: '1rem'}}>
                Avoid eating heavy meals close to bedtime as it can cause discomfort and disrupt sleep. Similarly, try to finish your exercise routine 
                at least a few hours before bed to allow your body time to wind down.
            </p>

            <p>
                Remember, improving sleep habits takes time and consistency. Experiment with these tips to find what works best for you and make 
                adjustments as needed. If you continue to experience persistent sleep problems, consider seeking guidance from a healthcare 
                professional or sleep specialist.
            </p>
        </div>
    )
}

export default BetterSleep